module.exports = __webpack_public_path__ + "static/media/pic7.b9aa5663.jpg";